import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./style/PhaseLayout.css";

import { AuthContext } from "../auth/AuthProvider";
import PhaseLayout1 from "./PhaseLayout1";
import PhaseLayout2 from "./PhaseLayout2";
import PhaseLayout3 from "./PhaseLayout3";
import PhaseLayout4 from "./PhaseLayout4";
import PhaseLayout5 from "./PhaseLayout5";
import PhaseQuestions from "./phaseQuestions/PhaseQuestions";

const themeSlug = [
  {
    id: 1,
    title: "love-and-disappointment",
  },
  {
    id: 2,
    title: "stress-and-fatigue",
  },
  {
    id: 3,
    title: "motivation-and-laziness",
  },
];

export default function PhaseLayout({ isopen, setisopen }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [phase, setPhase] = useState([]);
  const [themeAccess, setThemeAccess] = useState({});
  const [question, setQuestion] = useState([]);
  const [showPhase1, setShowPhase1] = useState({
    id1: 0,
    show: false,
  });

  const {
    user,
    userQuestion5,
    googleUserQuestion5,
    userQuestion2_5,
    googleUserQuestion2_5,
    userQuestion3_5,
    googleUserQuestion3_5,
    userQuestion4_5,
    googleUserQuestion4_5,
    payed,
    googleUser,
    apiUrl,
    setPayed,
    payedStressFatigue,
    setPayedStressFatigue,
  } = useContext(AuthContext);

  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${apiUrl}/question/byPhaseAndTheme/Phase 5/${id}`)
      .then((response) => {
        setQuestion(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((err) => {});

    axios
      .get(`${apiUrl}/phase/byTheme/${id}`)
      .then((response) => {
        setPhase(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((err) => {});
  }, [apiUrl, id]);

  useEffect(() => {
    async function getInfo() {
      try {
        const userType = user
          ? `username/${user.username}`
          : `googleEmail/${googleUser.email}`;

        const results = await Promise.all(
          themeSlug.map(async (ts) => {
            try {
              const res = await axios.get(
                `${apiUrl}/success/${userType}/${ts.title}`,
              );

              return {
                id: ts.id,
                title: ts.title,
                success: !!res.data[0],
              };
            } catch (error) {
              console.log(`Failed for ${ts.title}:`, error.response?.status);
              return {
                id: ts.id,
                title: ts.title,
                success: false,
              };
            }
          }),
        );

        const formatted = {};
        results.forEach((r) => {
          formatted[r.title] = r.success;
        });

        console.log("themeAccess:", formatted);
        setThemeAccess(formatted);
      } catch (error) {
        console.log("getInfo error:", error);
      }
    }

    if (user || googleUser) {
      getInfo();
    }
  }, [user, googleUser, apiUrl]);

  function phaseClick1(id11) {
    setShowPhase1((prevState) => ({
      id1: id11,
      show: !prevState.show,
    }));
  }

  return (
    <>
      <div className="phaseLayoutDiv">
        {phase.map((p) => (
          <div key={p.id}>
            {p.title === "Phase 1" ? (
              <PhaseLayout1 />
            ) : (p.title === "Phase 2" &&
                user &&
                userQuestion5[0] &&
                themeAccess[id] === true) ||
              (p.title === "Phase 2" &&
                googleUser &&
                googleUserQuestion5[0] &&
                themeAccess[id] === true) ? (
              <PhaseLayout2 />
            ) : (p.title === "Phase 3" && user && userQuestion2_5[0]) ||
              (p.title === "Phase 3" &&
                googleUser &&
                googleUserQuestion2_5[0]) ? (
              <PhaseLayout3 />
            ) : (p.title === "Phase 4" && user && userQuestion3_5[0]) ||
              (p.title === "Phase 4" &&
                googleUser &&
                googleUserQuestion3_5[0]) ? (
              <PhaseLayout4 />
            ) : (p.title === "Phase 5" && user && userQuestion4_5[0]) ||
              (p.title === "Phase 5" &&
                googleUser &&
                googleUserQuestion4_5[0]) ? (
              <PhaseLayout5 />
            ) : (
              <>
                <PhaseQuestions id11={p.id} />
              </>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
